/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardFilter {
    getFixupPrototypeFunction() { return ComplianceStandardFilter.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardFilter>): ComplianceStandardFilter {
        let obj = Object.assign(new ComplianceStandardFilter(), model);
        ComplianceStandardFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardFilter>): ComplianceStandardFilter {
        if (!model) return null;
        return ComplianceStandardFilter.newInstance(<ComplianceStandardFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardFilter) {
        if (!obj) return;

        models.ComplianceStandardFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardFilter): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Search based on name, compliance_standard_uri and description
     */
    search: string;

    /**
     * Query filter for supported_cloud_providers and scope
     */
    query: models.QueryOperator;

}
